import { Skeleton } from '@/shared/components/ui/skeleton';

interface WidgetCardSkeletonProps {
  h: number;
}

const ROW_HEIGHT_PX = 80;
const HEADER_HEIGHT_PX = 48;

export function WidgetCardSkeleton({ h }: WidgetCardSkeletonProps) {
  const contentHeight = h * ROW_HEIGHT_PX - HEADER_HEIGHT_PX;

  return (
    <div
      className="flex flex-col gap-3 rounded-lg border bg-card p-4"
      data-testid="dashboard-widget-card-skeleton"
      style={{ height: h * ROW_HEIGHT_PX }}
    >
      <Skeleton className="h-4 w-2/5 rounded" />
      <div className="flex flex-1 flex-col gap-2" style={{ height: contentHeight }}>
        <Skeleton className="h-8 w-1/3 rounded" />
        <Skeleton className="h-full w-full rounded" />
      </div>
    </div>
  );
}
